
var UStream = (function() {

  function fixUI(ustreamContainer) {
    var siblings = ustreamContainer.children("iframe").nextAll();
    ustreamContainer.after(siblings);
  }

  var ret = {
    fixUI: fixUI
  };
  return ret;

})();
